import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import './index.css';
import App from './App';
import { AlertProvider } from './context/AlertContext';

// Configuración de tema personalizado para Ant Design
const theme = {
  token: {
    colorPrimary: '#ff6da0',
    colorLink: '#ff6da0',
    borderRadius: 8,
    fontSize: 16,
  },
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ConfigProvider theme={theme}>
      <Router>
        <AlertProvider>
          <App />
        </AlertProvider>
      </Router>
    </ConfigProvider>
  </React.StrictMode>
);
